var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_51678)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_667_51678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.32617,
    y: 11.6914,
    width: 21.3767,
    height: 21.3767,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.282 24V32.3339H8.94922V11.3507L13.5348 5.68359H27.282V14.3273",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4344 5.68359V11.7471L9.00977 11.6582L13.4344 5.68359Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.248 18.377H19.2681H14.248Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.248 14.7754H19.2681H14.248Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2363 25.4958L17.4946 26.8349L19.8016 23.8555",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1694 25.0164C22.1694 27.255 20.3546 29.0698 18.116 29.0698C15.8773 29.0698 14.0625 27.255 14.0625 25.0164C14.0625 22.7777 15.8773 20.9629 18.116 20.9629C20.3546 20.9629 22.1694 22.7777 22.1694 25.0164Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7087 18.3274C28.8698 20.4891 29.9279 22.9363 29.071 23.7933C28.2134 24.6502 25.7662 23.5927 23.6051 21.431C21.4433 19.2699 20.3859 16.8227 21.2428 15.9657C22.0998 15.1081 24.5469 16.1663 26.7087 18.3274Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.623 13.5846C24.48 12.7277 26.9272 13.7851 29.0889 15.9469C31.2507 18.1086 32.3082 20.5558 31.4512 21.4128",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6225 13.584L21.2422 15.965L23.6225 13.584Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4507 21.4121L29.0703 23.7924L31.4507 21.4121Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4914 17.5893C30.4226 16.3233 31.1953 15.1622 32.1826 14.4356C32.4653 14.227 32.7708 14.0492 33.0903 13.9028C33.4132 13.7551 33.7568 13.6769 34.081 13.5405C34.6826 13.2879 35.1284 12.7384 35.2528 12.0987C35.4821 10.9122 34.5603 9.76916 33.3517 9.74643C32.7461 9.73507 32.1585 10.0085 31.7775 10.4791C31.5362 10.7778 31.4453 11.1168 31.3223 11.4704C31.2067 11.8032 31.0589 12.1248 30.8791 12.4282C30.1746 13.6201 28.8912 14.6221 27.4453 14.5432L30.4914 17.5893Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_667_51678",
    transform: "scale(0.0357143)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_51678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 35.9024,
    fill: "white",
    transform: "translate(4 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_667_51678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5203,
    height: 22.6341,
    fill: "white",
    transform: "translate(2.43945 9.80469)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_667_51678",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp);
export default __webpack_public_path__ + "static/media/Stamp.4884ad21ac225933f5442c819f990488.svg";
export { ForwardRef as ReactComponent };